import { makeMessages, makeTranslation } from 'utils'

const messages = {
  forgotPassword: 'forgot_password',
}

export default makeMessages(messages, makeTranslation('fields'))
